import { useEffect, useState } from "react";
import { initializeCodatLink, CodatLinkProps } from "@codat/sdk-link-types";

export const CodatLink = (props: CodatLinkProps & { baseUrl: string }) => {
  const [componentMount, setComponentMount] = useState<HTMLDivElement | null>(
    null
  );

  useEffect(() => {
    const target = componentMount;
    if (target && target.children.length === 0) {
      initializeCodatLink(target, props);
    }
    // CodatLink does not support changing props after initialisation.
  }, [componentMount]);

  return (
    <div
      style={{
        width: "460px",
        height: "840px",
        maxHeight: "95%",
        position: "fixed",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1,
      }}
      ref={setComponentMount}
    ></div>
  );
};
